import React, { useState, useEffect } from 'react';

const applyDarkMode = (isDarkMode) => {
    const root = document.documentElement;

    if (isDarkMode) {
        root.style.setProperty('--background-color', '#181D27');
        root.style.setProperty('--text-color', '#FAFAFA');
        root.style.setProperty('--title-color', '#ffffff');
        root.style.setProperty('--theme-full-black', '#ffffff');
        root.style.setProperty('--theme-black', '#ffffff');
        root.style.setProperty('--theme-white', '#181D27');
        root.style.setProperty('--gray-50', '#0A0D12');
        root.style.setProperty('--gray-100', '#181D27');
        root.style.setProperty('--gray-200', '#252B37');
        root.style.setProperty('--gray-300', '#414651');
        root.style.setProperty('--gray-400', '#535862');
        root.style.setProperty('--gray-500', '#717680');
        root.style.setProperty('--gray-600', '#A4A7AE');
        root.style.setProperty('--gray-700', '#D5D7DA');
        root.style.setProperty('--gray-800', '#E9EAEB');
        root.style.setProperty('--gray-900', '#F5F5F5');
        root.style.setProperty('--gray-950', '#FAFAFA');
        root.style.setProperty('--gray-975', '#FDFDFD');
    } else {
        root.style.setProperty('--background-color', '#ffffff');
        root.style.setProperty('--text-color', '#535862');
        root.style.setProperty('--title-color', '#181D27');
        root.style.setProperty('--theme-full-black', '#000000');
        root.style.setProperty('--theme-black', '#111111');
        root.style.setProperty('--theme-white', '#ffffff');
        root.style.setProperty('--gray-50', '#FDFDFD');
        root.style.setProperty('--gray-100', '#FAFAFA');
        root.style.setProperty('--gray-200', '#F5F5F5');
        root.style.setProperty('--gray-300', '#E9EAEB');
        root.style.setProperty('--gray-400', '#D5D7DA');
        root.style.setProperty('--gray-500', '#A4A7AE');
        root.style.setProperty('--gray-600', '#717680');
        root.style.setProperty('--gray-700', '#535862');
        root.style.setProperty('--gray-800', '#414651');
        root.style.setProperty('--gray-900', '#252B37');
        root.style.setProperty('--gray-950', '#181D27');
        root.style.setProperty('--gray-975', '#0A0D12');
    }
};

const DarkModeToggle = ({ t, initialMode, onToggle }) => {
    const [isDarkMode, setIsDarkMode] = useState(initialMode);

    useEffect(() => {
        const savedDarkMode = localStorage.getItem('isDarkMode');
        const mode = savedDarkMode === 'true';
        setIsDarkMode(mode);
        applyDarkMode(mode);
    }, []);

    const toggleDarkMode = () => {
        const newMode = !isDarkMode;
        setIsDarkMode(newMode);
        localStorage.setItem('isDarkMode', newMode);
        applyDarkMode(newMode);
        if (onToggle) onToggle(newMode);
    };

    return (
        <div className="dark-mode-toggle">
            <p>{isDarkMode ? t('components:rezimTamni') : t('components:rezimSvetli')} &nbsp;</p>
            <label className="switch">
                <input
                    type="checkbox"
                    checked={isDarkMode}
                    onClick={toggleDarkMode}
                />
                <div className="slider round">
                    {isDarkMode ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-moon-icon lucide-moon">
                            <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-sun-icon lucide-sun">
                            <circle cx="12" cy="12" r="4" />
                            <path d="M12 2v2" />
                            <path d="M12 20v2" />
                            <path d="m4.93 4.93 1.41 1.41" />
                            <path d="m17.66 17.66 1.41 1.41" />
                            <path d="M2 12h2" />
                            <path d="M20 12h2" />
                            <path d="m6.34 17.66-1.41 1.41" />
                            <path d="m19.07 4.93-1.41 1.41" />
                        </svg>
                    )}
                </div>
            </label>
        </div>
    );
};

export default DarkModeToggle;